/*
 * Version of project statement lines specific to customer
 */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Hidden, Grid, TableContainer, Table,  TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
// import AbEnvironment from '../auth/AbEnvironment';
import AppLogo from '../ui/AppLogo';
import { format } from 'date-fns';

// const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'auto',
      // [theme.breakpoints.up('xs')]: {
      //  padding: theme.spacing(1),
      // },
      // [theme.breakpoints.up('sm')]: {
      //   padding: theme.spacing(2),
      // },
      // [theme.breakpoints.up('md')]: {
      //   padding: theme.spacing(3),
      // },
    },
    tblHead: {
      backgroundColor: '#f1f1f1',
    },
    tblHeadRow: {
      height: 24,
    },
    tblCellPositive: {
      textAlign: 'right',
      color: '#006400'
    },
    tblCellNegative: {
      textAlign: 'right',
      color: 'red'
    },
    tblCellError: {
      textAlign: 'right',
      color: '#006400',
      textDecoration: 'line-through'
    },
    appnameitem: {
      marginLeft: 8,
    },
});


class CustomerProjectStatementLines extends React.Component {
  
  renderPaymentSourceTableCell= (accountId, paymentSource) => {
    if (!paymentSource) {
      return '';
    }

    return paymentSource;
  }

  render() {
    const classes = this.props.classes;
    const thenodes = this.props.cl.nodes;

    let noRowsToShow = false;
    if (thenodes.length === 1 && thenodes[0].transactionTime == null) {
      noRowsToShow = true;
    }

    return (
      <div className={classes.paper}>
        <TableContainer>
          <Table>
            <TableHead className={classes.tblHead}>
              <TableRow className={classes.tblHeadRow}>
                <TableCell>Date</TableCell> 
                <TableCell colSpan={2}>Item</TableCell>
                {/*<TableCell align="right"><Tooltip title='The app charge is the cost of a subscription billed by the app vendor'><div>Charge</div></Tooltip></TableCell>*/}
                <TableCell align="right"><Tooltip title='App subscription cost'><div>Cost</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Fees or discounts'><div>Fees</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Payment for subscriptions, services, and fees'><div>Payment</div></Tooltip></TableCell>
                <TableCell><Tooltip title='Funding source used for payment / payout'><div>Funding</div></Tooltip></TableCell>
                <TableCell align="right"><Tooltip title='Current balance'><div>Balance</div></Tooltip></TableCell>
              </TableRow>
            </TableHead>
            { noRowsToShow === false &&
            <TableBody>
              { thenodes.map(n => {
                let tdate = format(new Date(n.transactionTime), 'yyyy-MM-dd');
                //let tId = n.transactionId;
                let tType = n.transactionType;
                let psSource = null;
                let psOutAmt = null;
                let appName = null;
                let bindCardCharge = null;
                let bindCardRefund = null;
                let markup = null;
                let discount = false;
                let refund = false;
                let balance = null;
                let paymentStatus = 1;  // Only relevant to payment transactions, default to 1 (confirmed)
                let topupMessage = 'Top-up funding';

                let refundClass         = classes.tblCellPositive;
                let bindcardChargeClass = classes.tblCellNegative;
                let markupClass         = classes.tblCellNegative;
                let psOutAmtClass       = classes.tblCellPositive;

                // Use transaction type to determine what to show.
                if (tType === -1) { // Pending bindcard charge
                  bindCardCharge = '(' + Number(n.bindCardCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';

                  appName = n.appName;
                  
                } else if (tType === 0 || tType === 99) { // Bindcard charge or service
                  bindCardCharge = '(' + Number(n.bindCardCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';

                  let tmarkup = Number(n.markup);
                  if (n.passThroughFee != null) {
                    tmarkup = tmarkup + Number(n.passThroughFee);
                  }
                  if (tmarkup === 0) {
                    markup = '';
                  } else if (tmarkup <= 0) {
                    let mkup = tmarkup * -1;
                    markup = Number(mkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                    markupClass = classes.tblCellPositive;
                    discount = true;
                  } else {
                    markup = '(' + Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  }

                  appName = n.appName;
                } else if (tType === 6) { // Refund
                  let tCharge = n.bindCardCharge;
                  if (tCharge <= 0) {
                    bindCardRefund = '';
                    if (tCharge < 0) {
                      let rfund = tCharge * -1;
                      bindCardRefund = Number(rfund).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                    }
                  } else {
                    refundClass = classes.tblCellNegative;
                    bindCardRefund = '(' + Number(n.bindCardCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  }

                  let tmarkup = Number(n.markup);
                  if (n.passThroughFee != null) {
                    tmarkup = tmarkup + Number(n.passThroughFee);
                  }
                  if (tmarkup <= 0) {
                    let mkup = tmarkup * -1;
                    markup = Number(mkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                    markupClass = classes.tblCellPositive;
                    refund = true;
                  } else {
                    markup = '(' + Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                  }

                  appName = n.appName;
                } else if (tType === 1 || tType === 3 || tType === 8 || tType === 31) { // Funding source charge. 1 is normal, 3 is dunning, 8 is Topup, 31 is service charge
                  paymentStatus = n.paymentStatus;

                  if (n.psType == null) {
                    psSource = 'Balance';
                  } else if (n.psCcBrand != null) {
                    psSource = 'CC ***' + n.psCcLast4;
                  } else {
                    // psSource = 'ACH ***' + n.psAchAccountNum;
                    psSource = 'ACH';
                  }

                  let tmarkup = null;
                  if (n.markup != null) {
                    tmarkup = Number(n.markup);
                  }
                  if (n.passThroughFee != null) {
                    if (tmarkup != null) {
                      tmarkup = tmarkup + Number(n.passThroughFee);
                    } else {
                      tmarkup = Number(n.passThroughFee);
                    }
                  }
                  if (tType === 8 && n.psCFee != null) {
                    if (tmarkup != null) {
                      tmarkup = tmarkup + Number(n.psCFee);
                    } else {
                      tmarkup = Number(n.psCFee);
                    }
                  }
                  if (tmarkup != null) {
                    if (Number(tmarkup) === 0) {
                      /*
                      markupClass = classes.tblCellPositive;
                      markup = Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                      */
                      markup = '';
                    } else {
                      markup = '(' + Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                    }
                  }

                  psOutAmt = Number(n.psOutAmt).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                  if (paymentStatus < 0) {
                    topupMessage = 'Top-up failure';
                    psOutAmtClass = classes.tblCellError;
                  }
                } else if (tType === 4 || tType === 11) { // Payout
                  if (n.psCcBrand != null) {
                    psSource = 'CC ***' + n.psCcLast4;
                  } else {
                    // psSource = 'ACH ***' + n.psAchAccountNum;
                    psSource = 'ACH';
                  }
                } else if (tType === 15) {
                  //credit customer account
                  psOutAmt = Number(n.markup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                } else if (tType === 16) {
                  //debit customer account (fee)
                  let tmarkup = n.markup * -1;
                  markup = '(' + Number(tmarkup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                }

                // Balance is on all 
                if (n.balance < 0) {
                  let tbal = n.balance * -1;
                  balance = '(' + Number(tbal).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
                } else {
                  balance = Number(n.balance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                }

                //prepping data per row for display
                /*date column*/
                const dateElement =
                  tType === -1 ? (<i>{tdate}</i>) :
                  tType >= 0 ? (<>{tdate}</>) :
                  '';

                return (
                  <TableRow key={n.transactionId}>
                    <TableCell style={{whiteSpace: 'nowrap'}}>{dateElement}</TableCell>

                    {/* Item */}
                    { tType === -1 &&
                    <TableCell colSpan={2}>
                      <Grid container alignItems="center">
                        <Hidden lgDown>
                          <Grid item>
                            <AppLogo logoPath={n.appLogo} appName={appName} imageHeight='24px'/>
                          </Grid>
                          {appName != null &&
                          <Grid item className={classes.appnameitem}>
                            <Typography variant="subtitle2"><i>{appName}</i></Typography>
                          </Grid>
                          }
                        </Hidden>
                        <Hidden lgUp>
                          <Grid item>
                              <AppLogo logoPath={n.appLogo} appName={appName} imageHeight='24px' theTooltip={appName}/>
                          </Grid>
                        </Hidden>
                      </Grid>
                    </TableCell>
                    }
                    { (tType === 0 || tType === 6 || tType === 99) &&
                    <TableCell colSpan={2}>
                      <Grid container alignItems="center">
                        <Hidden lgDown>
                         
                          <Grid item>
                            <AppLogo logoPath={n.appLogo} appName={appName} imageHeight='24px'/>
                          </Grid>

                          {appName != null &&
                          <Grid item className={classes.appnameitem}>
                            <Typography variant="subtitle2">{appName}</Typography>
                          </Grid>
                          }
                        </Hidden>
                        <Hidden lgUp>
                          <Grid item>
                              <AppLogo logoPath={n.appLogo} appName={appName} imageHeight='24px' theTooltip={appName}/>
                          </Grid>
                        </Hidden>
                      </Grid>
                    </TableCell>
                    }
                    { tType === 1 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Subscription payment</Typography>
                    </TableCell>}
                    { tType === 31 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Services payment</Typography>
                    </TableCell>}
                    { tType === 3 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">Dunning payment</Typography>
                    </TableCell>}
                    {/* Topup transaction - indicate */}
                    { tType === 8 &&
                    <TableCell colSpan={2}>
                      <Typography variant="body2">{topupMessage}</Typography>
                    </TableCell>}
                    { (tType === 15 || tType === 16) &&
                      <TableCell colSpan={2}>
                        <Grid container alignItems="center">
                          <Grid item><AppLogo logoPath="/logos/appbind-128t.png" appName="AppBind" imageHeight='24px'/></Grid>
                          <Grid item className={classes.appnameitem}>
                            {n.paymentStatusReason && !(n.paymentStatusReason === 'Account credit' || n.paymentStatusReason === 'Account debit') ? n.paymentStatusReason : 
                            tType === 15 ? 'AppBind account credit' :
                            tType === 16 ? 'AppBind account debit' :
                            ''}
                          </Grid>
                        </Grid>
                     </TableCell>}
                    { tType > 0 && tType !== 1 && tType !== 3 && tType !== 6 && tType !== 8 && tType !== 15 && tType !== 16 && tType !== 31 && tType !== 99 &&
                    <TableCell colSpan={2}/>}

                    {/* Cost */}
                    { tType === -1 &&
                    <TableCell align="right"><i>{bindCardCharge}</i></TableCell>}
                    { tType >= 0 && tType !== 6 && tType !== 99 && !n.paidByBalance && 
                    <TableCell className={bindcardChargeClass}>{bindCardCharge}</TableCell>}
                    { tType >= 0 && tType !== 6 && tType !== 99 && (n.paidByBalance === 1) && 
                    <TableCell className={bindcardChargeClass} align="right"><Tooltip title='This app subscription was paid for with your project balance'><div><i>{bindCardCharge}</i></div></Tooltip></TableCell>}
                    { tType >= 0 && tType !== 6 && tType === 99  && 
                    <TableCell className={bindcardChargeClass} align="right"><Tooltip title='This service charge does not effect your project balance'><div><i>{bindCardCharge}</i></div></Tooltip></TableCell>}
                    { tType === 6 && n.bindCardCharge < 0 &&
                    <TableCell className={refundClass}><Tooltip title={'You were refunded subscription charges'}><div>{bindCardRefund}</div></Tooltip></TableCell>}
                    { tType === 6 && n.bindCardCharge === 0 &&
                    <TableCell className={refundClass}>{bindCardRefund}</TableCell>}
                    { tType === 6 && n.bindCardCharge >= 0 &&
                    <TableCell className={refundClass}>{bindCardRefund}</TableCell>}

                    {/* Payment? */}
                    { tType === -1 &&
                    <TableCell align="right"><i>Pending</i></TableCell>}
                    { tType >= 0 && tType !== 6 && tType !== 15 && tType !== 16 && discount &&
                    <TableCell className={markupClass}><Tooltip title={'You received a discount'}><div>{markup}</div></Tooltip></TableCell>}
                    { tType >= 0 && tType !== 6 && tType !== 15 && tType !== 16 && !discount &&
                    <TableCell className={markupClass}>{markup}</TableCell>}
                    { tType === 6 && refund &&
                    <TableCell className={markupClass}><Tooltip title={'You were refunded subscription fees'}><div>{markup}</div></Tooltip></TableCell>}
                    { tType === 6 && !refund &&
                    <TableCell className={markupClass}>{markup}</TableCell>}
                    { tType === 15 &&
                    <TableCell className={markupClass}>{markup}</TableCell>}
                    { tType === 16 &&
                    <TableCell className={markupClass}>{markup}</TableCell>}

                    { (tType !== 3 || psSource !== 'Balance') && tType !== 31 &&
                    <TableCell className={psOutAmtClass}>{psOutAmt}</TableCell>}
                    { tType === 3 && psSource === 'Balance' && tType !== 31  &&
                    <TableCell className={psOutAmtClass}><Tooltip title={'This dunning payment increases your available balance, but does not impact your total balance'}><div><i>{psOutAmt}</i></div></Tooltip></TableCell>}

                    { tType === 31  &&
                    <TableCell className={psOutAmtClass}><Tooltip title={'This services payment does not effect your project balance'}><div><i>{psOutAmt}</i></div></Tooltip></TableCell>}

                    {/* Last 2 columns: funding source & balance */}
                    <TableCell style={{whiteSpace: 'nowrap'}}>{this.renderPaymentSourceTableCell(n.accountId, psSource)}</TableCell>
                    <TableCell align="right">{balance}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody> }
          </Table>
        </TableContainer>
      </div>
    );

  } // end render()
}

CustomerProjectStatementLines.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(CustomerProjectStatementLines);
